export function ok(value) {
    return { ok: true, value };
}
export function fail(error) {
    return { ok: false, error };
}
//# sourceMappingURL=result.js.map